import React from "react";

// @ts-expect-error
import { freeGiftBannerWrapper } from "./free-gift-banner.module.scss";
import { Typography } from "@material-ui/core";

const FreeGiftBanner = ({ ignoreBSgridSidePadding = false, data }: { data?: Record<string, string>, ignoreBSgridSidePadding?: boolean }) => {
  return (
    <div
      style={
        ignoreBSgridSidePadding
          ? { marginRight: "-15px", marginLeft: "-15px" }
          : {}
      }
      className={freeGiftBannerWrapper}
    >
      <div className="text-column">
        <Typography variant="h6" color="textPrimary">
          {data && data.title ? data.title : 'Free Shipping & Free Gifts'}
        </Typography>
        <Typography
          variant="body2"
          color="textPrimary"
          style={{ fontSize: "1.4rem" }}
        >
          {data && data.subtitle ? data.subtitle : 'with kit purchase (up to $30 value)'}
        </Typography>
      </div>
      <div className="image-column">
        <img
          src="https://cdn.shopify.com/s/files/1/1540/8825/files/Copy_of_Kits_Ship_Free_Version_1.png?v=1685311961"
          alt=""
          className="img-fluid"
        />
      </div>
    </div>
  );
};

export default FreeGiftBanner;
